import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

const DELAY = { close: 200 };

interface IProps {
    tooltipText?: string;
}

const FiltersPanelInfoIcon = ({ tooltipText }: IProps) => {
    return (
        <Tooltip
            enabled={!!tooltipText}
            delay={DELAY}
            content={tooltipText}
        >
            <Info24px
                data-automation="info-icon"
                size="sm"
                color={colorsPalettes.carbon["200"]}
            />
        </Tooltip>
    );
};

export default FiltersPanelInfoIcon;
